/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAssetTypeSubsystemComponentclassResponseDtoShort } from './GetAssetTypeSubsystemComponentclassResponseDtoShort';
import {
    GetAssetTypeSubsystemComponentclassResponseDtoShortFromJSON,
    GetAssetTypeSubsystemComponentclassResponseDtoShortFromJSONTyped,
    GetAssetTypeSubsystemComponentclassResponseDtoShortToJSON,
    GetAssetTypeSubsystemComponentclassResponseDtoShortToJSONTyped,
} from './GetAssetTypeSubsystemComponentclassResponseDtoShort';

/**
 * 
 * @export
 * @interface GetAllMappingsRes
 */
export interface GetAllMappingsRes {
    /**
     * Array of asset-subsystem-componentclass mappings
     * @type {Array<GetAssetTypeSubsystemComponentclassResponseDtoShort>}
     * @memberof GetAllMappingsRes
     */
    data: Array<GetAssetTypeSubsystemComponentclassResponseDtoShort>;
    /**
     * Total number of mappings
     * @type {number}
     * @memberof GetAllMappingsRes
     */
    total: number;
}

/**
 * Check if a given object implements the GetAllMappingsRes interface.
 */
export function instanceOfGetAllMappingsRes(value: object): value is GetAllMappingsRes {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetAllMappingsResFromJSON(json: any): GetAllMappingsRes {
    return GetAllMappingsResFromJSONTyped(json, false);
}

export function GetAllMappingsResFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllMappingsRes {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(GetAssetTypeSubsystemComponentclassResponseDtoShortFromJSON)),
        'total': json['total'],
    };
}

export function GetAllMappingsResToJSON(json: any): GetAllMappingsRes {
    return GetAllMappingsResToJSONTyped(json, false);
}

export function GetAllMappingsResToJSONTyped(value?: GetAllMappingsRes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(GetAssetTypeSubsystemComponentclassResponseDtoShortToJSON)),
        'total': value['total'],
    };
}

